import { Flex, Skeleton } from '@skin-seoul/design-system';
import type { ComponentProps } from 'react';
import React from 'react';

type HorizontalProductCardSkeletonProps = ComponentProps<typeof Flex>;

export const HorizontalProductCardSkeleton = ({ ...props }: HorizontalProductCardSkeletonProps) => {
  return (
    <Flex width="100%" height="147px" position="relative" {...props}>
      <Flex
        borderRadius="8px"
        overflow="hidden"
        direction="row"
        height="100%"
        width="100%"
        alignItems="center"
        backgroundColor="generic.0"
      >
        <Skeleton width="130px" height="100%" borderRadius="8px 0 0 8px" />
        <Flex direction="row" flex="1" height="100%" justifyContent="space-between" px={3}>
          <Flex direction="column" gap={3} flex="1" height="100%" justifyContent="center">
            <Flex direction="column" gap={2}>
              <Skeleton borderRadius="4px" height="14px" width="120px" />
              <Skeleton borderRadius="4px" height="14px" width="100%" />
              <Skeleton borderRadius="4px" height="14px" width="80%" />
              <Skeleton borderRadius="4px" height="16px" width="80px" />
            </Flex>
            <Skeleton borderRadius="4px" height="20px" width="90%" />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};
